import { LayoutActionTypes } from './types';

export const openLeftMenu = () => ({ type: LayoutActionTypes.OPEN_LEFT_MENU });
export const closeLeftMenu = () => ({ type: LayoutActionTypes.CLOSE_LEFT_MENU });
export const lockLeftMenu = () => ({ type: LayoutActionTypes.LOCK_NAVIGATION });
export const unLockLeftMenu = () => ({ type: LayoutActionTypes.UNLOCK_NAVIGATION });
